import { DarkLogo, LogoCollpased, QRScanIcon, XCloseIcon } from "assests";
import { Button } from "components/UI/Button";
import Divider from "components/UI/Divider";
import TabItem from "components/UI/TabItem";
import Cookies from "js-cookie";
import { useEffect, useState, useRef } from "react";
import { IoIosArrowForward } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useParams } from "react-router-dom";
import { setCurrentWorkspace } from "store/authenticationSlice";
import { toggleShowSidebarMessage, toggleShowSidebarMessage2 } from "store/billingSlice";
import { closeOpenSections, collapseSidebar, toggleSection } from "store/navbarSlice";
import { toggleTheme } from "store/themeSlice";
import { isEqual } from "lodash";
import { SidebarMenu, SidebarMenuSettings } from "utils/constant";
// import { permissions } from "utils/permissions";
import CollapsMenu from "./CollapsMenu";
import { greeting, transpercencyPercentageColors } from "utils/helper";
import usePermission from "hooks/usePermission";
import { LineProgressBar } from "components/UI/LineProgressBar";
const LeftSidebar = () => {
  const dispatch = useDispatch();
  const permissions = JSON.parse(localStorage.getItem("permissions"));
  const { isSidebarCollapsed, openSections } = useSelector((state) => state.navbarSlice);
  const { user, subscription, workspaces, currentWorkspace } = useSelector(
    (state) => state.authenticationSlice,
  );
  const { pathname } = useLocation();
  const { workspaceId } = useParams();
  const { userPermission } = usePermission();

  //local state
  const [maxHeight, setMaxHeight] = useState(null);
  const [filteredMenu, setFilteredMenu] = useState(null);

  // Helper to find the relevant role for the current workspace
  const getWorkspaceRole = (roles, workspaceId) => {
    if (!roles || !Array.isArray(roles)) return null;
    return roles.find(
      (item) =>
        !item.name.split(".").includes("workspace") &&
        parseInt(item.pivot.workspace_id) === parseInt(workspaceId) &&
        item.name !== "workspace.admin",
    );
  };

  // Helper to build current workspace data
  const buildWorkspaceData = (user, role, workspaceId, workspaces) => {
    const data = {
      role_name: role?.name || user.role,
      workspace_id: parseInt(role?.pivot.workspace_id || workspaceId),
      is_owner: parseInt(user.workspace_id) === parseInt(workspaceId),
      user_workspace_id: parseInt(user.workspace_id),
      invited_workspace_name: null,
      invited_workspace_type: null,
      invited_workspace_id: null,
    };

    if (data.workspace_id && workspaces?.length > 0) {
      const ws = workspaces.find(
        (item) => (item.invited_workspace_id || item.pivot.workspace_id) === data.workspace_id,
      );
      if (ws) {
        data.invited_workspace_name = ws.invited_workspace_name;
        data.invited_workspace_type = ws.invited_workspace_type;
        data.invited_workspace_id = ws.invited_workspace_id;
      }
    }

    return data;
  };

  // Helper to filter sidebar menu based on permissions
  const filterSidebarMenu = (sidebarMenu, workspaceData, permissions, userPermission) => {
    const updatedMenu = Object.keys(sidebarMenu).reduce((acc, key) => {
      let menuItems = sidebarMenu[key].filter((item) => {
        if (workspaceData.is_owner && workspaceData.role_name) {
          return permissions[workspaceData.role_name]?.ownerMenuItems?.includes(item.path);
        } else {
          if (item.path === "setting") return false;
          if (key === "compliancy") return true;
          return permissions[workspaceData.role_name]?.invitedMenuItems?.includes(item.path);
        }
      });

      // Additional filtering for main_menu and compliancy
      if (key === "main_menu" && menuItems.length > 0) {
        if (
          !subscription &&
          workspaceData.is_owner &&
          workspaceData.role_name &&
          workspaceData.role_name.includes("retailer")
        ) {
          menuItems = menuItems.filter((item) => item.path !== "articles");
        } else {
          menuItems = menuItems.filter(
            (item) => item.path !== "articles" || userPermission("view_article.can"),
          );
        }
      }

      if (key === "compliancy") {
        if (!userPermission("view_certificate.can") && !userPermission("view_audit.can")) {
          return acc; // skip adding this section
        }
        if (menuItems.length > 0) {
          menuItems = menuItems.filter(
            (item) =>
              (item.path !== "certificates" || userPermission("view_certificate.can")) &&
              (item.path !== "audits" || userPermission("view_audit.can")),
          );
        }
        //temporary condition for retailer account on agent and supplier workspace
        if (
          currentWorkspace &&
          currentWorkspace.role_name.includes("retailer") &&
          (currentWorkspace.invited_workspace_type === "agent" ||
            currentWorkspace.invited_workspace_type === "supplier")
        ) {
          return acc; // skip adding this section
        }

        //temporary condition for supplier account on agent and retailer workspace
        if (currentWorkspace && currentWorkspace.role_name.includes("supplier")) {
          return acc; // skip adding this section
        }
      }

      if (menuItems.length > 0) acc[key] = menuItems;
      return acc;
    }, {});

    return updatedMenu;
  };
  const prevWorkspaceDataRef = useRef(null);
  const prevSidebarMenuRef = useRef(null);
  useEffect(() => {
    if (!user || !permissions) return;

    const currentWorkspaceId = pathname.includes("workspace") ? workspaceId : user.workspace_id;
    const role = getWorkspaceRole(user.roles, currentWorkspaceId);

    if (!role) return;

    const workspaceData = buildWorkspaceData(user, role, currentWorkspaceId, workspaces);

    // Only dispatch if workspaceData actually changed
    if (!isEqual(prevWorkspaceDataRef.current, workspaceData)) {
      dispatch(setCurrentWorkspace(workspaceData));
      prevWorkspaceDataRef.current = workspaceData;
    }

    const updatedSidebarMenu = filterSidebarMenu(
      SidebarMenu,
      workspaceData,
      permissions,
      userPermission,
    );

    // Only setFilteredMenu if it changed
    if (!isEqual(prevSidebarMenuRef.current, updatedSidebarMenu)) {
      setFilteredMenu(updatedSidebarMenu);
      prevSidebarMenuRef.current = updatedSidebarMenu;
    }
  }, [pathname, user, workspaceId, workspaces, permissions, dispatch]);

  useEffect(() => {
    const screenHeight = window.innerHeight;
    if (screenHeight < 668) {
      setMaxHeight("220px");
    } else if (screenHeight <= 768) {
      setMaxHeight("350px");
    } else if (screenHeight <= 920) {
      setMaxHeight("400px");
    } else {
      setMaxHeight(null);
    }
  }, [window.innerHeight]);

  // Toggle the open state for a specific section (e.g., partners or compliancy)
  const handleOpen = (key) => {
    if (isSidebarCollapsed) {
      dispatch(collapseSidebar());
    }
    dispatch(toggleSection(key));
  };
  function upgradeShowHIde() {
    var element = document.getElementById("upgradePlan").classList.remove("hidden");
  }

  function upgradeShowHIdeQRScan() {
    var element = document.getElementById("qrscanMsg").classList.remove("hidden");
  }

  useEffect(() => {
    let itemStatus = JSON.parse(localStorage.getItem("subscription"));
    if (!subscription && !itemStatus) {
      const isPlanNotUpgraded = Cookies.get("showSidebarMsg") || false;
      const parseIsPlanNotUpgraded = JSON.parse(isPlanNotUpgraded);
      if (parseIsPlanNotUpgraded) {
        dispatch(toggleShowSidebarMessage(true));
        upgradeShowHIde();
      }
    } else if (subscription) {
      Cookies.set("showSidebarMsg", "false", { expires: 7 });
      dispatch(toggleShowSidebarMessage(false));
      document.getElementById("upgradePlan").classList.add("hidden");
      localStorage.removeItem("subscription");
    }
  }, [subscription, isSidebarCollapsed]);

  useEffect(() => {
    const isQrScanNotShowing = Cookies.get("showSidebarMsg2") || false;
    const parseIsQrScanNotShowing = JSON.parse(isQrScanNotShowing);
    if (parseIsQrScanNotShowing) {
      dispatch(toggleShowSidebarMessage2(true));
      upgradeShowHIdeQRScan();
    }
  }, [isSidebarCollapsed]);

  const handleCloseSidebarMessage = () => {
    Cookies.set("showSidebarMsg", "false", { expires: 7 });
    dispatch(toggleShowSidebarMessage(false));
    document.getElementById("upgradePlan").classList.add("hidden");
    localStorage.removeItem("subscription");
  };

  const handleCloseSidebarMessage2 = () => {
    Cookies.set("showSidebarMsg2", "false", { expires: 7 });
    dispatch(toggleShowSidebarMessage(false));
    document.getElementById("qrscanMsg").classList.add("hidden");
  };

  const handleCloseOpenSections = () => {
    // List of possible keys to check
    const keysToCheck = ["partners", "compliancy"];
    // Filter only open ones
    const openKeys = keysToCheck.filter((key) => openSections[key]);
    dispatch(closeOpenSections(openKeys));
  };

  const closeSidebarSmallScreen = () => {
    dispatch(collapseSidebar());
    if (!isSidebarCollapsed) {
      handleCloseOpenSections();
    }
  };

  return (
    <>
      {window.innerWidth <= 767 && !isSidebarCollapsed && (
        <div className="fixed inset-0 transition-opacity bg-[#444656] bg-opacity-50 z-[100]"></div>
      )}
      <div
        className={`${window.innerWidth <= 767 && !isSidebarCollapsed ? "absolute left-0 w-[80vw] z-[100]" : "md:pl-1  py-1 bg-transparent"} `}
      >
        <div
          className={`flex items-center justify-center flex-col gap-0 pt-10 pb-4 relative shadow-md ${isSidebarCollapsed ? "w-0 md:w-16 px-0 md:px-3" : "md:w-[292px] px-4"} h-screen  md:h-full lg:rounded-xl  md:ring-1 md:ring-inset md:ring-[#8E8F98] bg-global-sidebar-bg transition-all duration-300`}
        >
          <div>
            <div className="relative pb-10">
              <div className="">
                <Link
                  to={"/"}
                  className={`flex justify-center gap-3 ${isSidebarCollapsed ? "hidden md:block" : ""}`}
                >
                  {isSidebarCollapsed ? <LogoCollpased /> : <DarkLogo />}
                </Link>
              </div>
            </div>
          </div>

          <div
            className="flex flex-col flex-1 pb-1 w-full gap-2  overflow-y-clip no-scrollbar"
            style={{ height: "100%", overflowY: "auto" }}
          >
            {filteredMenu &&
              Object.keys(filteredMenu).map((key, index) => {
                const menuItems = filteredMenu[key];
                if (menuItems && menuItems?.length > 0) {
                  return (
                    <div key={index} className="flex flex-col gap-2">
                      <div className="flex flex-col gap-2">
                        <div className="flex flex-col gap-1">
                          {key === "partners" || key === "compliancy" ? (
                            <CollapsMenu
                              isOpen={openSections[key]}
                              itemKey={key}
                              menuItems={menuItems}
                              pathname={pathname}
                              handleOpen={handleOpen}
                              closeSidebarSmallScreen={closeSidebarSmallScreen}
                            />
                          ) : (
                            menuItems?.map((item, itemIndex) => (
                              <TabItem
                                item={item}
                                key={itemIndex}
                                pathname={pathname}
                                closeSidebarSmallScreen={closeSidebarSmallScreen}
                              />
                            ))
                          )}
                        </div>
                      </div>
                      {(key === "main_menu" ||
                        key === "compliancy" ||
                        (currentWorkspace &&
                          currentWorkspace.invited_workspace_type === "supplier" &&
                          key === "partners")) && <Divider className="!bg-[#8E8F98]" />}
                      {/* temporary condition for supplier account on agent and retailer workspace */}
                      {currentWorkspace &&
                        currentWorkspace.role_name.includes("supplier") &&
                        ["agent", "retailer", "importer", "brand"].includes(
                          currentWorkspace.invited_workspace_type,
                        ) &&
                        key === "partners" && <Divider className="!bg-[#8E8F98]" />}
                      {/* temporary condition for retailer account on agent and supplier workspace */}
                      {currentWorkspace &&
                        currentWorkspace.role_name.includes("retailer") &&
                        ["agent"].includes(currentWorkspace.invited_workspace_type) &&
                        key === "partners" && <Divider className="!bg-[#8E8F98]" />}
                    </div>
                  );
                }
              })}
          </div>

          <div
            className={`flex flex-col gap-4 pt-5 w-full ${isSidebarCollapsed ? "hidden md:block" : ""}`}
          >
            <div
              id="qrscanMsg"
              className={` flex-col hidden  ${isSidebarCollapsed ? "hidden" : ""}`}
              style={{}}
            >
              {!isSidebarCollapsed &&
                currentWorkspace &&
                currentWorkspace.is_owner &&
                !currentWorkspace.role_name.includes("supplier") && (
                  <div className="">
                    <div className="w-full bg-gray-800 h-[182px] p-4 rounded-xl border border-white ">
                      <div className="grid gap-1.5 text-sm ">
                        <div>
                          <div className="flex justify-between items-center">
                            <div className="font-semibold text-white text-sm">Coming Soon</div>
                            <div>
                              <XCloseIcon
                                onClick={handleCloseSidebarMessage2}
                                width={20}
                                height={20}
                                strokeColor="var(--color-gray-extra-3)"
                                className="cursor-pointer"
                              />
                            </div>
                          </div>
                          <h3 className="font-normal py-1 text-white text-sm ">
                            Get ready for AI powered Carbon Footprint calculation.
                          </h3>
                        </div>

                        <div className="px-6 py-3 h-20 bg-white border border-gray-300 rounded-2xl w-full">
                          <div className="flex flex-col justify-start items-start gap-3">
                            <div className="text-xs font-medium text-gray-extra-2">
                              Impact kg C02 eq
                            </div>
                            <div className="w-full">
                              <div className="flex justify-between items-center gap-3 py-[3px] w-full">
                                <div className="text-gray-extra-6 font-medium text-sm">0.87</div>
                                <LineProgressBar
                                  className="h-2 w-full"
                                  variant={"green"}
                                  progress={70}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
            </div>
            <div
              id="upgradePlan"
              className={` flex-col hidden   ${isSidebarCollapsed ? "hidden" : ""}`}
              style={{}}
            >
              {!isSidebarCollapsed &&
                currentWorkspace &&
                !currentWorkspace.role_name.includes("supplier") && (
                  <div className="">
                    <div className="w-full bg-menu-item-surface-active h-[132px] p-4 rounded-xl  ">
                      <div className="grid gap-4 text-sm text-global-theme">
                        <div>
                          <div className="flex justify-between items-center">
                            <div className="font-semibold">Upgrade plan</div>
                            <div>
                              <XCloseIcon
                                onClick={handleCloseSidebarMessage}
                                width={20}
                                height={20}
                                className="cursor-pointer "
                              />
                            </div>
                          </div>

                          <h3 className="font-normal pt-1 ">
                            Invite partners and get access to all{" "}
                            <span className="uppercase">PRO</span> features.
                          </h3>
                        </div>
                        <div className="flex items-center gap-3">
                          <Button
                            onClick={handleCloseSidebarMessage}
                            variant="link"
                            className="p-0 m-0 text-sm text-global-theme"
                          >
                            Dismiss
                          </Button>
                          <Link
                            to={`/workspace/${currentWorkspace?.user_workspace_id}/setting?selectedTab=plan`}
                          >
                            <Button
                              variant="link"
                              className="p-0 m-0 text-sm text-global-primary cursor-pointer"
                            >
                              Upgrade plan
                            </Button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
            </div>

            <Divider className={isSidebarCollapsed ? "hidden" : "!bg-[#8E8F98]"} />

            <div
              className={`px-2 pt-1 pb-5 relative justify-end items-center gap-4 inline-flex ${isSidebarCollapsed ? "hidden" : ""}`}
            >
              <div className="grow shrink basis-0  justify-start items-center gap-2 flex">
                <div className="w-10 h-10 relative rounded-full">
                  <div className="flex justify-center items-center p-0 ring-1 ring-global-divider-soft rounded-full border-none text-btn-text-default bg-transparent">
                    {user && user?.image ? (
                      <div className="!w-10 h-10">
                        <img
                          src={`${user?.image}?t=${new Date().getTime()}`}
                          alt={`Profile`}
                          className="rounded-full !w-10 h-10"
                        />
                      </div>
                    ) : (
                      <div className="flex bg-global-surface justify-center items-center uppercase text-base font-semibold text-text-quaternary w-10 h-10  p-0 ring-1 ring-global-divider-soft  rounded-full border-none">
                        {user &&
                          `${user?.first_name?.substring(0, 1)}${user?.last_name?.substring(0, 1)}`}
                      </div>
                    )}
                  </div>
                  <div className="w-2.5 h-2.5 left-[30px] top-[30px] absolute bg-[#17b169] rounded-full border border-white" />
                </div>
                <div className="grid ">
                  <p className="text-sm leading-5 font-semibold text-white truncate">{greeting}</p>
                  <p className="text-sm font-normal leading-5 text-white truncate">{user?.name}</p>
                </div>
              </div>
            </div>
          </div>
          <div
            onClick={() => {
              dispatch(collapseSidebar());
              if (!isSidebarCollapsed) {
                handleCloseOpenSections();
              }
            }}
            className={` bg-menu-item-surface-active w-8 h-8 flex items-center justify-center rounded-md  cursor-pointer z-[100] ${isSidebarCollapsed ? "rotate-0 hidden md:flex " : "rotate-180 absolute bottom-4 right-4"}`}
            style={{
              boxShadow:
                "0px 1px 2px 0px rgba(10, 13, 18, 0.05),0px -2px 0px 0px rgba(10, 13, 18, 0.05) inset, 0px 0px 0px 1px rgba(10, 13, 18, 0.18) inset",
            }}
          >
            <IoIosArrowForward size={20} color="var(--color-white)" />
          </div>
          <Divider className={`${isSidebarCollapsed ? "block my-4" : "hidden"}`} />
          <div
            className={`px-2 pt-1 pb-5 relative justify-end items-center gap-4  ${isSidebarCollapsed ? "hidden md:inline-flex" : "hidden"}`}
          >
            <div className="grow shrink basis-0  justify-start items-center gap-2 flex">
              <div className="w-10 h-10 relative rounded-full">
                <div className="flex justify-center items-center p-0 ring-1 ring-global-divider-soft rounded-full border-none text-btn-text-default bg-transparent">
                  {user && user?.image ? (
                    <div className="!w-10 h-10">
                      <img
                        src={`${user?.image}?t=${new Date().getTime()}`}
                        alt={`Profile`}
                        className="rounded-full !w-10 h-10"
                      />
                    </div>
                  ) : (
                    <div className="flex bg-global-surface justify-center items-center uppercase text-base font-semibold text-text-quaternary w-10 h-10  p-0 ring-1 ring-global-divider-soft  rounded-full border-none">
                      {user &&
                        `${user?.first_name?.substring(0, 1)}${user?.last_name?.substring(0, 1)}`}
                    </div>
                  )}
                </div>
                <div className="w-2.5 h-2.5 left-[30px] top-[30px] absolute bg-[#17b169] rounded-full border border-white" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeftSidebar;
